import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  NodeStatus,
  OrgInfo,
  REF_MODEL_STORE,
  RefModelNode,
  RefModelStoreService,
  Refmodel,
  TakeUntilComponentDestroy
} from '@q9elements/ui-kit/common';
import {Observable} from 'rxjs';

import {FollowingService} from './services/following.service';

@Component({
  selector: 'app-sidebar-wrapper',
  templateUrl: './sidebar-wrapper.component.html',
  styleUrls: ['./sidebar-wrapper.component.scss']
})
export class SidebarWrapperComponent
  extends TakeUntilComponentDestroy
  implements OnInit, OnDestroy
{
  @Input() showDeleteNodesButton: boolean;
  @Input() isRefModel: boolean;
  @Input() impactTreeRootNode?: RefModelNode;
  @Input() isDependencyTree: boolean;

  @Output() removeMultipleNodes: EventEmitter<any> = new EventEmitter<any>();

  public refModelData$: Observable<Refmodel> = this.rmeStore.select(REF_MODEL_STORE.REF_MODEL);
  public orgInfo$: Observable<OrgInfo> = this.rmeStore.select<OrgInfo>(REF_MODEL_STORE.ORG_INFO);
  public selectedNode$: Observable<RefModelNode> = this.rmeStore.select<RefModelNode>(
    REF_MODEL_STORE.SELECTED_NODE
  );
  public areNodesDeleting$: Observable<boolean>;
  public showDependencyTreeButton = true;
  public showCodeSearchReferencesButton = true;
  public selectedNode: RefModelNode;

  constructor(
    private rmeStore: RefModelStoreService,
    private followingService: FollowingService
  ) {
    super();
  }

  ngOnInit() {
    this.areNodesDeleting$ = this.rmeStore.select(REF_MODEL_STORE.ARE_NODES_DELETING);

    this.subscribeToSelectedNode();
  }

  public toggleFollow(sidebarData: RefModelNode) {
    this.followingService.toggleFollow(sidebarData).subscribe(
      () => {
        sidebarData.followLevel = sidebarData.followLevel < 1 ? sidebarData.followLevel + 1 : -1;
        const node = Object.assign({}, sidebarData);
        this.rmeStore.set<RefModelNode>(REF_MODEL_STORE.SELECTED_NODE, node);
      },
      err => console.error('Failed to update follow: ', err)
    );
  }

  private setShowCodeSearch(): void {
    this.showCodeSearchReferencesButton =
      this.rmeStore.user.userInTeam.team.plan.proPlus &&
      this.rmeStore.isEditor &&
      this.selectedNode?.status !== NodeStatus.PROPOSED &&
      Boolean(this.selectedNode?.sf?.id);
  }

  private subscribeToSelectedNode() {
    this.selectedNode = this.impactTreeRootNode;
    this.setShowCodeSearch();

    if (this.impactTreeRootNode) {
      this.showDependencyTreeButton = this.impactTreeRootNode._id !== this.selectedNode._id;
    }
  }

  ngOnDestroy(): void {
    return;
  }
}
